import { ChevronRight, ChevronLeft } from 'lucide-react'
import { useTranslation } from 'react-i18next'

export default function Pagination({ page, totalPages, total, limit, onPageChange }) {
  const { t } = useTranslation()
  if (!totalPages || totalPages <= 1) return null

  const pages = Array.from({ length: Math.min(totalPages, 7) }, (_, i) => {
    if (totalPages <= 7) return i + 1
    if (page <= 4) return i + 1
    if (page >= totalPages - 3) return totalPages - 6 + i
    return page - 3 + i
  })

  return (
    <div className="flex items-center justify-between pt-4" style={{ borderTop: '1px solid #EEEEEE' }}>
      <span
        className="text-sm text-ghost"
        style={{ fontFamily: 'Tajawal, sans-serif' }}
      >
        {t('common.total')}: {total || 0}
      </span>

      <div className="flex items-center gap-1">
        <button
          onClick={() => onPageChange(page - 1)}
          disabled={page <= 1}
          className="p-2 rounded-lg transition-all hover:bg-surface-band disabled:opacity-30 disabled:cursor-not-allowed"
          style={{ color: '#000666' }}
        >
          <ChevronRight size={16} />
        </button>

        {pages.map((p) => (
          <button
            key={p}
            onClick={() => onPageChange(p)}
            className="w-8 h-8 rounded-lg text-sm font-bold transition-all"
            style={{
              background: p === page ? '#000666' : 'transparent',
              color: p === page ? '#fff' : '#767683',
              fontFamily: 'Cairo, sans-serif',
            }}
          >
            {p}
          </button>
        ))}

        <button
          onClick={() => onPageChange(page + 1)}
          disabled={page >= totalPages}
          className="p-2 rounded-lg transition-all hover:bg-surface-band disabled:opacity-30 disabled:cursor-not-allowed"
          style={{ color: '#000666' }}
        >
          <ChevronLeft size={16} />
        </button>
      </div>
    </div>
  )
}
